import React from 'react';
export const spinnerSize = {
    xsmall: 14,
    small: 16,
    medium: 20,
    large: 24,
    iconOnly: 20
};
